import IOrientation from './IOrientation';
import IBrightness from './IBrightness';

export interface TakeAndUploadScreenshotResult {
	/** URL of the uploaded screenshot. */
	screenshotUrl: string;
	/** aHash of the screenshot, if computed. */
	aHash?: string;
}

/** Options for taking and uploading a screenshot. */
export interface TakeAndUploadScreenshotOptions {
	/** Whether to compute the hash of the screenshot. Default is false. */
	computeHash?: boolean;
	/** Additional headers to include in the upload request. */
	headers?: Record<string, string>;
}

export const VTakeAndUploadScreenshotOptions = {
	computeHash: '?boolean',
	headers: '?object',
};

export default interface IScreen {
	resize(baseUrl: string, orientation: string, resolution: string, currentVersion: string, videoOrientation?: string): Promise<void>;
	getOrientation(): Promise<IOrientation>;
	setBrightness(timeFrom1: string, brightness1: number, timeFrom2: string, brightness2: number): Promise<void>;
	getBrightness(): Promise<IBrightness>;
	/** @deprecated use takeAndUploadScreenshot(uploadBaseUrl: string, computeHash?: boolean): Promise<TakeAndUploadScreenshotResult> */
	takeAndUploadScreenshot(uploadBaseUrl: string): Promise<string>;
	/** @deprecated use takeAndUploadScreenshot(uploadBaseUrl: string, options: TakeAndUploadScreenshotOptions): Promise<TakeAndUploadScreenshotResult> */
	takeAndUploadScreenshot(uploadBaseUrl: string, computeHash?: boolean): Promise<TakeAndUploadScreenshotResult>;
	takeAndUploadScreenshot(uploadBaseUrl: string, options: TakeAndUploadScreenshotOptions): Promise<TakeAndUploadScreenshotResult>;
	powerOn(): Promise<void>;
	powerOff(): Promise<void>;
	isPoweredOn(): Promise<boolean>;
}
